/**
 * Lead Service (Legacy Wrapper)
 *
 * 이 파일은 하위 호환성을 위해 유지됩니다.
 * 내부적으로 _new/api/modules/lead.ts를 사용합니다.
 *
 * @deprecated 새로운 코드에서는 `import { leadApi } from '@new/api'`를 사용하세요.
 */
import { leadApi } from '@new/api';

async function createLead(leadData) {
  // 새로운 leadApi.createLead를 사용
  const response = await leadApi.createLead(leadData);

  // 기존 코드와의 호환성을 위해 response.data를 반환
  return response.data;
}

export { createLead };
